import { ChecklistItem } from '../../atoms/ChecklistItem/ChecklistItem';
import { memo } from 'react';
import classes from 'classnames';
import styles from './Checklist.module.scss';

export type ChecklistProps = {
  className?: string;
  items: string[];
};

export const Checklist: React.FC<ChecklistProps> = memo(
  ({ className, items }) => {
    return (
      <div className={classes(styles.container, className)}>
        {items.map((item, index) => (
          <ChecklistItem key={index} text={item} />
        ))}
      </div>
    );
  },
);
